import z from "zod";

// import * as process from 'node:process';

const defaultHost = "http://localhost:3043/";

export const EnvType = z.object({
  authUrl: z.url(),
  grpcUrl: z.url(),
});

export type Env = z.infer<typeof EnvType>;
export const Env: Env = EnvType.parse({
  authUrl: process.env.PUBLIC__OM_AUTH_URL ?? defaultHost,
  grpcUrl: process.env.PUBLIC__OM_GRPC_URL ?? `${defaultHost}grpc`,
});

export default Env;
